import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import ComponentTable from '../../../Components/Table/Index';
import { Column } from '../../../Components/Table/Types';
import * as Icon from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';
import { GrupoClienteAtulizar, GrupoClienteCadastrar } from '../../../../routes/RoutesNames';
import { useSelector } from 'react-redux';
import GrupoClienteController from '../../../../controllers/GrupoClienteController';
import { toast } from 'react-toastify';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { Button } from '../../../../shared/components/button/Button';
import { ButtonMenu } from '../../../../shared/components/ButtonMenu'
import FormBuilder from '../../../../shared/components/FormBuilder';

interface Row {
  BtnEditar?: JSX.Element;
  BtnExcluir?: JSX.Element;
  grucli_id: number;
  grucli_descricao: string;
}

export default function GrupoCliente() {
  const userId = useSelector((state: any) => state.Authentication.userId);
  const navigate = useNavigate();
  const tableColumns: Column[] = [
    { id: 'Id', label: 'Código', minWidth: 0, align: 'center' },
    { id: 'Descricao', label: 'Descrição', minWidth: 0 },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, align: 'right' },
  ];
  const fields = [
    { name: 'GrupoClienteId', label: 'Código', type: 'number', col: 3 },
    { name: 'Descricao', label: 'Descrição', type:'text', col: 3 },
    { type: 'submit', icon: (<Icon.Search style={{ fontSize: '28px' }} />), col: 1 }
  ];
  const initialValues = {
    GrupoClienteId: null,
    Descricao: '',
  };
  const [tableRows, setTableRows] = useState<Row[]>([]);

  const handleNavigation = async (): Promise<void> => {
    navigate(GrupoClienteCadastrar);
  };

  const handleEditItem = (item: Row, duploClick = false, duploClickId = 0) => {
    if (duploClick) {
      navigate(GrupoClienteAtulizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } });
    }
    else {
      navigate(GrupoClienteAtulizar.replace(':id', item.grucli_id.toString()));
    }
  };

  const handleDeleteItem = async (grucli_id: number) => {
    const request: any = { UsuId: userId, GrupoClienteId: grucli_id };
    const response = await GrupoClienteController.Excluir(request);

    if (response.StatusCode === 204) {
      toast('Grupo cliente excluído com sucesso!', {
        type: 'success',
      });
      handleSubmit(initialValues);
    } else {
      toast('Erro ao excluir o grupo cliente!', {
        type: 'error',
      });
    }
  };

  const handleSubmit = async (values: any) => {
    const DataRows: any = [];
    const Response = await GrupoClienteController.Listar(values);

    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.map((item: Row) => {
        DataRows.push({
          Id: item.grucli_id,
          Descricao: item.grucli_descricao,
          BtnMenu: (
            <ButtonMenu
              items={[
                { onClick: () => handleEditItem(item), menu: "Editar" },
                { onClick: () => handleDeleteItem(item.grucli_id), menu: "Excluir", confirmar: `Excluir o grupo de cliente "${item.grucli_descricao ?? ''}"? Esta ação não pode ser desfeita.` },
              ]}
            />
          ),
        });

        setTableRows(DataRows);
      });
    } else if (Response.StatusCode === 204 && Response?.Data?.length === 0) {
      toast('Não há registros cadastrados.', {
        type: 'warning',
      });
    } else {
      toast(Response?.Data, {
        type: 'success',
      });
    }
  };

  useEffect(() => {
    handleSubmit(initialValues);
  }, []);

  return (
    <Box>
      <HeaderComponent
        text={'Grupo Clientes'}
        ButtonRight={
          <Button
            className={''}
            variant='success'
            onClick={handleNavigation}
            iconStart={<Icon.Add />}
            title={'Incluir'}
          />
        }
      />
      <FormBuilder fields={fields} initialValues={initialValues} onSubmit={handleSubmit} gap='gap-3' />
      <ComponentTable columns={tableColumns} rows={tableRows} onRowDoubleClick={(row) => {
        handleEditItem(row, true, row.Id);
      }} />
    </Box>
  );
}
